import { Typography as MuiTypography, TypographyProps } from "@mui/material";

import { theme } from "../mui-customs/Theme";

interface ErrorMessage extends TypographyProps {
  message?: string;
}

const ErrorMessage = ({ message = "", sx, ...other }: ErrorMessage) => {
  return (
    <MuiTypography
      sx={{
        fontSize: "0.75rem",
        marginLeft: "14px",
        color: theme.brand2[900],
        ...sx,
      }}
    >
      {message}
    </MuiTypography>
  );
};

export default ErrorMessage;
